import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";
import WaveSurfer from "wavesurfer.js";
import '../App.scss'

const AudioPlayer = forwardRef(({ audioUrl, onPlayStateChange }, ref) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);

  useImperativeHandle(ref, () => ({
    play() {
      if (wavesurfer.current) wavesurfer.current.play();
    },
    pause() {
      if (wavesurfer.current) wavesurfer.current.pause();
    },
    stop() {
      if (wavesurfer.current) wavesurfer.current.stop();
    },
  }));

  useEffect(() => {
    const timeout = setTimeout(() => {
      wavesurfer.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: "#ccc",
        progressColor: "#000000",
        cursorColor: "blue",
        height: 50,
        barWidth: 2,
        barRadius: 2,
        responsive: true,
      });

      wavesurfer.current.load(audioUrl);

      /* ---- On ready ---- */
      wavesurfer.current.on("ready", () => {
        setDuration(wavesurfer.current.getDuration());
      });

      /* ---- SYNC EVENTS ---- */
      wavesurfer.current.on("play", () => {
        setPlaying(true);
        if (onPlayStateChange) onPlayStateChange(true);
      });

      wavesurfer.current.on("pause", () => {
        setPlaying(false);
        if (onPlayStateChange) onPlayStateChange(false);
      });

      wavesurfer.current.on("finish", () => {
        setPlaying(false);
        if (onPlayStateChange) onPlayStateChange(false);
      });
    }, 150);

    return () => {
      clearTimeout(timeout);
      if (wavesurfer.current) wavesurfer.current.destroy();
    };
  }, [audioUrl]);

  const handlePlayPause = () => {
    wavesurfer.current.playPause();
    setPlaying(!playing);
  };

  // Helper to format time in mm:ss format.
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <div className="voice-player" style={{ position: "relative" }}>
      {/* Play/Pause Button positioned in the center of the waveform */}
      <button onClick={handlePlayPause}>
        {playing ? "⏸" : "▶"}
      </button>

      {/* Waveform container */}
      <div
        id="waveform"
        ref={waveformRef}
      ></div>

      {/* Display the total audio duration at the end of the waveform */}
      <div
        style={{
          padding: "2px 4px",
          borderRadius: "4px",
          fontSize: "14px",
        }}
      >
        {formatTime(duration)}&nbsp;
      </div>
    </div>
  );
});

export default AudioPlayer;
